<template>
  <Legacy
    view="invoicing"
    action="generateInvoices"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Generate Invoice',
      breadcrumb: {
        name: 'Generate Invoice',
        route: { name: 'billing-generate' }
      }
    }
  }
}
</script>
